import React, { useState } from "react";
import Select from "react-select";
import { useParams } from "react-router-dom";
import * as Components from "../../../components/all";
import { TbActivityHeartbeat } from "react-icons/tb";
import { GiClick } from "react-icons/gi";
import { FaUserClock } from "react-icons/fa";
import { BiListCheck } from "react-icons/bi";

export default function TrendsPS() {
	const params = useParams();
	const [loading, setLoading] = useState(false);

	// Select Tag Types
	const [activityType, setActivityType] = useState("30");
	const [clickType, setClickType] = useState("30");
	const [impressionType, setImpressionType] = useState("30");
	const [bookingsType, setBookingsType] = useState("30");

	// Trend Data
	var PSdata = {
		parkingSpaceName: "Comsats University Islamabad, Islamabad",
		userActivity: {
			last30Days: 2000,
			last6Months: 30500,
			lastYear: 71200,
		},
		clicks: {
			last30Days: 2000,
			last6Months: 30500,
			lastYear: 71200,
		},
		impressions: {
			last30Days: 2000,
			last6Months: 30500,
			lastYear: 71200,
		},
		bookings: {
			last30Days: 2000,
			last6Months: 30500,
			lastYear: 71200,
		},
	};

	// settings
	var settings = {
		selectStyles: {
			control: (provided, state) => ({
				...provided,
				minHeight: "30px",
				height: "30px",
				boxShadow: state.isFocused ? null : null,
			}),

			valueContainer: (provided, state) => ({
				...provided,
				height: "30px",
				padding: "0 8px 0 8px",
			}),

			input: (provided, state) => ({
				...provided,
				margin: "0px",
			}),

			indicatorSeparator: (state) => ({
				display: "none",
			}),

			indicatorsContainer: (provided, state) => ({
				...provided,
				height: "30px",
			}),
		},
	};

	return loading === true ? (
		<Components.Loader />
	) : (
		<div
			className="ParkingSpacesTrends
            overflow-x-hidden overflow-y-auto 
            h-full
            w-full
            sm:p-3 md:p-5
            flex flex-col
            "
		>
			{/* TOP CARDS ROW */}
			<div className="TOP-CARDS flex flex-col sm:flex-row sm:items-stretch sm:justify-between sm:flex-wrap">
				{/* card 1 */}
				<div
					style={{
						boxShadow: "0px 2px 6px rgb(20 20 20 / 0.1)",
					}}
					className="
					min-h-[80px]
					sm:min-w-[350px] flex-1
                    p-5 m-2
					overflow-hidden
                    rounded-md
                    bg-white 
                    flex flex-col
                    duration-150 ease-in-out
                    "
				>
					{/* heading */}
					<div
						className="
							w-full
							px-2 
							flex 
							items-center justify-between 
							flex-wrap
							"
					>
						<div className="flex items-center">
							<Components.BackButton />

							<h1 className="ml-2 font-medium text-lg">
								{PSdata.parkingSpaceName}
							</h1>
						</div>
					</div>
				</div>
			</div>

			{/* MIDDLE CARDS ROW */}
			<div className="MIDDLE-CARDS flex flex-col sm:flex-row sm:items-stretch sm:justify-between sm:flex-wrap">
				{/* card 1 */}
				<div
					style={{
						boxShadow: "0px 2px 6px rgb(20 20 20 / 0.1)",
					}}
					className="
					min-h-[220px]
					sm:min-w-[350px] flex-1
                    p-5 m-2
					overflow-hidden
                    rounded-md
                    bg-white 
                    flex flex-col
                    duration-150 ease-in-out
                    "
				>
					{/* heading */}
					<div
						className="
							w-full
							px-2 pb-7 
							flex 
							items-center justify-between 
							flex-wrap
							"
					>
						<div className="flex items-center">
							<div
								className="
									h-6 w-6
									flex items-center justify-center
									rounded-full
                                    bg-[#fedddd] 
                                    text-[#FA9499]
									"
							>
								<GiClick />
							</div>
							<h1 className="ml-2 text-darker">Clicks</h1>
						</div>

						<Select
							className="text-sm"
							styles={settings.selectStyles}
							options={[
								{ value: "30", label: "Last 30 Days" },
								{ value: "6", label: "Last 6 Months" },
								{ value: "12", label: "Last Year" },
							]}
							defaultValue={{ value: "30", label: "Last 30 Days" }}
							onChange={(e) => setClickType(e.value)}
						/>
					</div>

					{/* data */}
					<div className="my-auto w-full">
						<div className="w-fit mx-auto">
							<h1 className="text-3xl font-medium tracking-tighter text-center">
								{clickType === "30" &&
									PSdata.clicks.last30Days.toLocaleString()}
								{clickType === "6" &&
									PSdata.clicks.last6Months.toLocaleString()}
								{clickType === "12" && PSdata.clicks.lastYear.toLocaleString()}

								<span className="text-base tracking-normal ml-2">Clicks</span>
							</h1>
							<h2
								className="text-dark 
											mt-1 
											text-center
											"
							>
								Clicks on parking space page in app
							</h2>
						</div>
					</div>
				</div>

				{/* card 2 */}
				<div
					style={{
						boxShadow: "0px 2px 6px rgb(20 20 20 / 0.1)",
					}}
					className="
					min-h-[220px]
					sm:min-w-[350px] flex-1
                    p-5 m-2
					overflow-hidden
                    rounded-md
                    bg-white 
                    flex flex-col
                    duration-150 ease-in-out
                    "
				>
					{/* heading */}
					<div
						className="
							w-full
							px-2 pb-7 
							flex 
							items-center justify-between 
							flex-wrap
							"
					>
						<div className="flex items-center">
							<div
								className="
									h-6 w-6
									flex items-center justify-center
									rounded-full
                                    bg-[#DBF6ED] 
                                    text-[#8DBEAD]
									"
							>
								<BiListCheck />
							</div>
							<h1 className="ml-2 text-darker">Impressions</h1>
						</div>

						<Select
							className="text-sm"
							styles={settings.selectStyles}
							options={[
								{ value: "30", label: "Last 30 Days" },
								{ value: "6", label: "Last 6 Months" },
								{ value: "12", label: "Last Year" },
							]}
							defaultValue={{ value: "30", label: "Last 30 Days" }}
							onChange={(e) => setImpressionType(e.value)}
						/>
					</div>

					{/* data */}
					<div className="my-auto w-full">
						<div className="w-fit mx-auto">
							<h1 className="text-3xl font-medium tracking-tighter text-center">
								{impressionType === "30" &&
									PSdata.impressions.last30Days.toLocaleString()}
								{impressionType === "6" &&
									PSdata.impressions.last6Months.toLocaleString()}
								{impressionType === "12" &&
									PSdata.impressions.lastYear.toLocaleString()}

								<span className="text-base tracking-normal ml-2">
									Impressions
								</span>
							</h1>
							<h2
								className="text-dark 
											mt-1 
											text-center
											"
							>
								Impressions of parking space in app
							</h2>
						</div>
					</div>
				</div>
			</div>

			{/* BOTTOM CARDS ROW */}
			<div className="BOTTOM-CARDS flex flex-col sm:flex-row sm:items-stretch sm:justify-between sm:flex-wrap">
				{/* card 1 */}
				<div
					style={{
						boxShadow: "0px 2px 6px rgb(20 20 20 / 0.1)",
					}}
					className="
					min-h-[220px]
					sm:min-w-[350px] flex-1
                    p-5 m-2
					overflow-hidden
                    rounded-md
                    bg-white 
                    flex flex-col
                    duration-150 ease-in-out
                    "
				>
					{/* heading */}
					<div
						className="
							w-full
							px-2 pb-7 
							flex 
							items-center justify-between 
							flex-wrap
							"
					>
						<div className="flex items-center">
							<div
								className="
									h-6 w-6
									flex items-center justify-center
									rounded-full
                                    bg-[#dfe6ff] 
                                    text-main
									"
							>
								<TbActivityHeartbeat />
							</div>
							<h1 className="ml-2 text-darker">User Activity</h1>
						</div>

						<Select
							className="text-sm"
							styles={settings.selectStyles}
							options={[
								{ value: "30", label: "Last 30 Days" },
								{ value: "6", label: "Last 6 Months" },
								{ value: "12", label: "Last Year" },
							]}
							defaultValue={{ value: "30", label: "Last 30 Days" }}
							onChange={(e) => setActivityType(e.value)}
						/>
					</div>

					{/* data */}
					<div className="my-auto w-full">
						<div className="w-fit mx-auto">
							<h1 className="text-3xl font-medium tracking-tighter text-center">
								{activityType === "30" &&
									PSdata.userActivity.last30Days.toLocaleString()}
								{activityType === "6" &&
									PSdata.userActivity.last6Months.toLocaleString()}
								{activityType === "12" &&
									PSdata.userActivity.lastYear.toLocaleString()}

								<span className="text-base tracking-normal ml-2">Visits</span>
							</h1>
							<h2
								className="text-dark 
											mt-1 
											text-center
											"
							>
								Activity in parking space
							</h2>
						</div>
					</div>
				</div>

				{/* card 2 */}
				<div
					style={{
						boxShadow: "0px 2px 6px rgb(20 20 20 / 0.1)",
					}}
					className="
					min-h-[220px]
					sm:min-w-[350px] flex-1
                    p-5 m-2
					overflow-hidden
                    rounded-md
                    bg-white 
                    flex flex-col
                    duration-150 ease-in-out
                    "
				>
					{/* heading */}
					<div
						className="
							w-full
							px-2 pb-7 
							flex 
							items-center justify-between 
							flex-wrap
							"
					>
						<div className="flex items-center">
							<div
								className="
									h-6 w-6
									flex items-center justify-center
									rounded-full
                                    bg-[#ffbd427b] 
                                    text-[#ffaa00]
									"
							>
								<FaUserClock />
							</div>
							<h1 className="ml-2 text-darker">Bookings</h1>
						</div>

						<Select
							className="text-sm"
							styles={settings.selectStyles}
							options={[
								{ value: "30", label: "Last 30 Days" },
								{ value: "6", label: "Last 6 Months" },
								{ value: "12", label: "Last Year" },
							]}
							defaultValue={{ value: "30", label: "Last 30 Days" }}
							onChange={(e) => setBookingsType(e.value)}
						/>
					</div>

					{/* data */}
					<div className="my-auto w-full">
						<div className="w-fit mx-auto">
							<h1 className="text-3xl font-medium tracking-tighter text-center">
								{bookingsType === "30" &&
									PSdata.bookings.last30Days.toLocaleString()}
								{bookingsType === "6" &&
									PSdata.bookings.last6Months.toLocaleString()}
								{bookingsType === "12" &&
									PSdata.bookings.lastYear.toLocaleString()}

								<span className="text-base tracking-normal ml-2">Bookings</span>
							</h1>
							<h2
								className="text-dark 
											mt-1 
											text-center
											"
							>
								Bookings in parking space
							</h2>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}
